import React, { useState } from 'react';
import { DomainSelector } from '../common/components/domain/DomainSelector';
import { DomainScopedErrorBoundary } from '../common/components/errors/boundaries/DomainScopedErrorBoundary';
import { Domains } from '../constants';
import {
  DomainContext,
  DomainSetterContext,
  useNullableDomainContext,
} from '../context/contexts';
import { DomainScopedContextProvider } from '../context/DomainScopedContextProvider';

export const DomainGuard = ({ children }: { children: React.ReactNode }) => {
  const domain = useNullableDomainContext();
  const [selectedDomain, setSelectedDomain] = useState<Domains | null>(domain);
  console.log('[alex] DomainGuard', selectedDomain);

  if (selectedDomain === null) {
    return (
      <DomainSelector
        selectedDomain={selectedDomain}
        setSelectedDomain={setSelectedDomain}
      />
    );
  }

  return (
    <DomainContext.Provider value={selectedDomain}>
      <DomainSetterContext.Provider value={setSelectedDomain}>
        <DomainScopedContextProvider>
          <DomainScopedErrorBoundary>{children}</DomainScopedErrorBoundary>
        </DomainScopedContextProvider>
      </DomainSetterContext.Provider>
    </DomainContext.Provider>
  );
};
